import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Loading from '../../components/Loading'
import SimpleActionPopup from '../../components/SimpleActionPopup'
import FormInput from '../../components/FormInput'
import { createCategory, createProduct, deleteCategory, deleteProduct, emptyCategory, getColoringProductsV2, updateCategory, updateProduct } from '../../services/utils'
import { successToast, errorToast } from '../../helpers/ToastHelper'
import { Add, Edit, Delete, PhotoCamera, CloudUpload } from '@material-ui/icons'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { COLORING_TYPES } from './utils'
import CategoryPopup from './components/CategoryPopup'
import ProductPopup from './components/ProductPopup'
import BulkUploadPopup from './components/BulkUploadPopup'

const ColoringManagement = props => {
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingContent, setIsLoadingContent] = useState(true)
  const [selectedSubgroup, setSelectedSubgroup] = useState(null)
  const [selectedColoring, setSelectedColoring] = useState('inverno_brilhante')
  const [showCategoryPopup, setShowCategoryPopup] = useState(false)
  const [showProductPopup, setShowProductPopup] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isDeletingCategory, setIsDeletingCategory] = useState(false);
  const [showEmptyConfirm, setShowEmptyConfirm] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState('');
  const [showBulkPopup, setShowBulkPopup] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadTotal, setUploadTotal] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState('all');

  const GROUP_OPTIONS = [
    { id: 'all', label: 'Todos os Grupos' },
    { id: 'make_up', label: 'Maquiagem' },
    { id: 'hair', label: 'Cabelo' },
    { id: 'look', label: 'Looks' },
    { id: 'accessory', label: 'Acessórios' },
  ]

  useEffect(() => {
    fetchData()
  }, [selectedColoring])

  const handleCreateCategory = async (payload) => {
    // Validar se tem imagem antes de começar
    if (!payload.file) {
      return errorToast('Por favor, selecione um ícone para a categoria.')
    }

    setIsLoading(true) // Mostra o loading global ou o do popup
    
    const formData = new FormData()
    // O nome 'image' deve ser o mesmo que você colocou no back-end: upload.single('image')
    formData.append('image', payload.file)
    formData.append('title_pt', payload.title_pt)
    formData.append('group_type', payload.group_type)
    formData.append('rank', payload.rank || 0)

    try {
      await createCategory(props.token, formData)
      
      successToast('Categoria criada com sucesso!')
      setShowCategoryPopup(false)
      
      // Recarregar os dados para exibir a nova categoria na lista
      await fetchData() 
    } catch (e) {
      // O erro já é tratado pelo wrappedRequest (toast), 
      // mas você pode logar ou tratar algo específico aqui
      console.error('Erro ao criar categoria:', e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleOpenEditCategory = (subgroup) => {
    setSelectedCategory(subgroup);
    setShowCategoryPopup(true);
  };

  const handleUpdateCategory = async (payload) => {
    setIsLoading(true);
    const formData = new FormData();
    if (payload.file) formData.append('image', payload.file);
    formData.append('title_pt', payload.title_pt);
    formData.append('group_type', payload.group_type);
    formData.append('rank', payload.rank);

    try {
      await updateCategory(props.token, selectedCategory.id, formData); // criar no utils.js
      successToast('Categoria atualizada!');
      setShowCategoryPopup(false);
      setSelectedCategory(null);
      fetchData(true);
    } catch (e) { console.error(e) } finally { setIsLoading(false) }
  };

  const openDeleteCategory = (subgroup) => {
    setItemToDelete(subgroup);
    setIsDeletingCategory(true);
    setShowDeletePopup(true);
  };

  const handleCreateProduct = async (payload) => {
    if (!payload.file) return errorToast('Selecione uma imagem para o produto.');

    setIsLoading(true);
    
    const formData = new FormData();
    formData.append('image', payload.file);
    formData.append('title_pt', payload.title_pt);
    formData.append('link', payload.link);
    formData.append('rank', payload.rank);
    formData.append('subgroup_id', selectedSubgroup.id); // Pega do estado que setamos ao abrir o popup
    formData.append('coloring_type', selectedColoring); // Pega do dropdown do topo

    try {
      await createProduct(props.token, formData);
      successToast('Produto adicionado!');
      setShowProductPopup(false);
      fetchData(true);
      scrollToCategory();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async (silent = false) => {
    if (!silent) setIsLoadingContent(true) 
    setIsFetching(true)

    try {
      const res = await getColoringProductsV2(props.token, selectedColoring, 'true')
      const groupOrder = { 'make_up': 1, 'hair': 2, 'look': 3, 'accessory': 4 }
      const sortedCategories = res.sort((a, b) => {
        if (groupOrder[a.group] !== groupOrder[b.group]) {
          return groupOrder[a.group] - groupOrder[b.group]
        }
        return a.rank - b.rank
      })
      setCategories(sortedCategories)
    } catch (e) {
      errorToast('Erro ao carregar dados')
    } finally {
      setIsLoadingContent(false)
      setIsFetching(false)
    }
  }
  const handleOpenEdit = (product, subgroup) => {
    setSelectedProduct(product);
    setSelectedSubgroup(subgroup);
    setShowProductPopup(true);
  };

  const handleUpdateProduct = async (payload) => {
    setIsLoading(true);
    const formData = new FormData();
    
    // Só adiciona o arquivo se o usuário selecionou um novo
    if (payload.file) formData.append('image', payload.file);
    
    formData.append('title_pt', payload.title_pt);
    formData.append('link', payload.link);
    formData.append('rank', payload.rank);

    try {
      await updateProduct(props.token, selectedProduct.id, formData);
      successToast('Produto atualizado!');
      setShowProductPopup(false);
      fetchData(true);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const openDeleteConfirm = (product) => {
    setItemToDelete(product);
    setShowDeletePopup(true);
  };

  const handleConfirmDelete = async () => {
    try {
      if (isDeletingCategory) {
        await deleteCategory(props.token, itemToDelete.id);
        successToast('Categoria removida com sucesso!');
      } else {
        await deleteProduct(props.token, itemToDelete.id);
        successToast('Produto removido com sucesso!');
      }
      setShowDeletePopup(false);
      setItemToDelete(null);
      setIsDeletingCategory(false);
      fetchData(true);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmptyCategory = async () => {
    setIsLoading(true);
    try {
      await emptyCategory(props.token, selectedSubgroup.id, selectedColoring);
      successToast('Categoria esvaziada!');
      setShowEmptyConfirm(false);
      fetchData(true);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkUpload = async (files) => {
    setIsLoading(true);
    setUploadTotal(files.length);
    setUploadProgress(0);        
    let successCount = 0;

    // Processa um por um para garantir que as traduções e S3 não deem gargalo
    for (const file of files) {
      const formData = new FormData();
      
      // Limpa o nome do arquivo para o título (o que fizemos no outro popup)
      let fileName = file.name.split('.').slice(0, -1).join('.');
      fileName = fileName.replace(/[_-]/g, ' ').charAt(0).toUpperCase() + fileName.slice(1);

      formData.append('image', file);
      formData.append('title_pt', fileName);
      formData.append('subgroup_id', selectedSubgroup.id);
      formData.append('coloring_type', selectedColoring);
      formData.append('rank', 0);

      try {
        await createProduct(props.token, formData);
        successCount++;
      } catch (e) {
        console.error(`Erro ao subir ${file.name}`);
      }finally {
        setUploadProgress(prev => prev + 1);
      }
    }

    successToast(`${successCount} produtos adicionados com sucesso!`);
    setShowBulkPopup(false);
    setIsLoading(false);
    fetchData(true);
    setUploadTotal(0); // Reseta
    setUploadProgress(0);
  };

  const scrollToCategory = (id) => {
    setTimeout(() => {
      const element = document.getElementById(`category-${id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100); // Pequeno delay para o React renderizar o novo item
  };

  // Componente de Card de Produto
  const ProductCard = ({ product, onEdit, onDelete }) => (
    <div className="relative group bg-white border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
      <img 
        src={product.url} 
        alt={product.title_pt} 
        className="w-full h-40 object-contain bg-gray-50 cursor-pointer" 
        onClick={() => {
          setPreviewImageUrl(product.url);
          setShowImagePreview(true);
        }}
      />
      <div className="p-3">
        <p className="text-xs font-bold text-gray-700 truncate">{product.title_pt || 'Sem título'}</p>
        <p className="text-[10px] text-gray-500 truncate">{product.link || 'Sem link'}</p>
      </div>
      {/* Overlay de Ações */}
      <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        <button onClick={onEdit} className="p-1 bg-white rounded-full shadow text-blue-600 hover:bg-blue-50"><Edit fontSize="small" /></button>
        <button onClick={onDelete} className="p-1 bg-white rounded-full shadow text-red-600 hover:bg-red-50"><Delete fontSize="small" /></button>
      </div>
    </div>
  )

  return (
    <div className='content-screen-container bg-gray-50 min-h-screen p-6'>
       {/* HEADER E FILTROS */}
      <div className='bg-white p-6 rounded-2xl shadow-sm mb-8 flex flex-col md:flex-row justify-between items-center gap-6'>
        <div>
          <h2 className="text-2xl font-black text-purple-900">Curadoria de Coloração</h2>
          <p className="text-gray-400 text-sm">Gerencie produtos e categorias por estação</p>
        </div>
        
        <div className="flex items-center gap-6 w-full md:w-auto">
          {/* SELETOR DE GRUPO (FILTRO) */}
           <FormControl variant="outlined" className="w-48" size="small">
             <InputLabel id="select-group-label">Filtrar por Grupo</InputLabel>
             <Select
               labelId="select-group-label"
               value={selectedGroup}
               onChange={(e) => setSelectedGroup(e.target.value)}
               label="Filtrar por Grupo"
               style={{ borderRadius: 12, backgroundColor: '#f9f9f9' }}
             >
               {GROUP_OPTIONS.map(group => (
                 <MenuItem key={group.id} value={group.id}>{group.label}</MenuItem>
               ))}
             </Select>
           </FormControl>

           {/* SELETOR DE ESTAÇÃO */}
           <FormControl variant="outlined" className="w-52" size="small">
             <InputLabel id="select-coloring-label">Estação Selecionada</InputLabel>
             <Select
               labelId="select-coloring-label"
               value={selectedColoring}
               onChange={(e) => setSelectedColoring(e.target.value)}
               label="Estação Selecionada"
               style={{ borderRadius: 12 }}
             >
               {COLORING_TYPES.map(type => (
                 <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
               ))}
             </Select>
           </FormControl>

           <button 
              className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-2.5 rounded-xl font-bold transition-all shadow-md"
              onClick={() => setShowCategoryPopup(true)}
            >
             <Add /> NOVA CATEGORIA
           </button>
        </div>
      </div>

      {isLoadingContent ? <Loading /> : (
        <div className="space-y-10">
         {categories
         .filter(subgroup => selectedGroup === 'all' || subgroup.group === selectedGroup)
         .map(subgroup => (
            <div 
              key={subgroup.id} 
              id={`category-${subgroup.id}`}
              className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm"
            >
              <div className="flex justify-between items-center mb-6 border-b pb-4">
                <div className="flex items-center gap-4">
                  <img src={subgroup.url} className="w-12 h-12 rounded-lg object-cover border" alt="cat" />
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-lg font-bold text-gray-800">{subgroup.title_pt}</h3>
                      {/* BOTÕES DA CATEGORIA */}
                      <button onClick={() => handleOpenEditCategory(subgroup)} className="text-gray-400 hover:text-blue-500"><Edit style={{ fontSize: 16 }} /></button>
                      <button onClick={() => openDeleteCategory(subgroup)} className="text-gray-400 hover:text-red-500"><Delete style={{ fontSize: 16 }} /></button>
                      <button 
                        onClick={() => { setSelectedSubgroup(subgroup); setShowEmptyConfirm(true); }}
                        className="text-gray-400 hover:text-orange-500 flex items-center gap-1 ml-4 border-l pl-4"
                        title="Esvaziar categoria"
                      >
                        <Delete fontSize="small" /> <span className="text-[10px] font-bold">LIMPAR TUDO</span>
                      </button>
                    </div>
                    <span className="text-xs uppercase bg-gray-100 px-2 py-1 rounded text-gray-600">{subgroup.group}</span>
                    <span className="bg-purple-100 text-purple-700 text-[10px]  px-2 py-0.5 rounded-full border border-purple-200 ml-2">
                      {subgroup.products?.length || 0} PRODUTOS
                    </span>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button 
                    onClick={() => { setSelectedSubgroup(subgroup); setShowBulkPopup(true); }}
                    className="text-gray-500 hover:bg-gray-100 px-3 py-2 rounded-lg flex items-center gap-1 text-[10px] font-black border border-gray-200"
                  >
                    <CloudUpload fontSize="small" /> EM MASSA
                  </button>
                  
                  <button 
                    onClick={() => { setSelectedSubgroup(subgroup); setShowProductPopup(true); }}
                    className="text-primary hover:bg-purple-50 px-3 py-2 rounded-lg flex items-center gap-1 text-sm font-bold border border-purple-100"
                  >
                    <Add fontSize="small" /> ADICIONAR PRODUTO
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                {subgroup.products.map(product => (
                  <ProductCard 
                    key={product.id} 
                    product={product} 
                    onEdit={() => handleOpenEdit(product, subgroup)}
                    onDelete={() => openDeleteConfirm(product)}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      
      {showCategoryPopup && (
        <CategoryPopup
          category={selectedCategory} 
          onClose={() => {
            setShowCategoryPopup(false)
            setSelectedCategory(null)
          }} 
          onSubmit={selectedCategory ? handleUpdateCategory : handleCreateCategory}
          isLoading={isLoading} 
        />
      )}

      {showProductPopup && (
        <ProductPopup
          subgroup={selectedSubgroup}
          product={selectedProduct}
          onClose={() => {
            setShowProductPopup(false)
            setSelectedProduct(null)
          }} 
          onSubmit={selectedProduct ? handleUpdateProduct : handleCreateProduct} 
          isLoading={isLoading}
        />
      )}

      {showDeletePopup && (
        <SimpleActionPopup
          title={isDeletingCategory ? "Excluir Categoria" : "Confirmar Exclusão"}
          onClosePopup={() => {
            setShowDeletePopup(false);
            setIsDeletingCategory(false);
          }}
          showClose={!isLoading}
          popupLoading={isLoading}
          containerStyle={{ maxWidth: '450px' }}
          // Ações
          firstActionButtonText="CANCELAR"
          onPressFirstActionButton={() => {
            setShowDeletePopup(false);
            setIsDeletingCategory(false);
          }}
          secondActionButtonText={isDeletingCategory ? "REMOVER CATEGORIA" : "SIM, REMOVER"}
          secondActionButtonStyle={{ backgroundColor: '#ff4d4d', borderColor: '#ff4d4d' }}
          onPressSecondActionButton={handleConfirmDelete} 
          content={(
            <div className='p-4 text-center'>
              <div className='mb-4 flex justify-center'>
                <img 
                  src={itemToDelete?.url} 
                  className={`w-24 h-24 rounded-lg border shadow-sm bg-gray-50 ${isDeletingCategory ? 'object-cover' : 'object-contain'}`} 
                  alt="preview"
                />
              </div>
              <p className='big-paragraph' style={{ color: 'var(--identity-9)' }}>
                Você tem certeza que deseja remover {isDeletingCategory ? 'a categoria' : 'o produto'} <strong>{itemToDelete?.title_pt}</strong>?
              </p>
              
              {isDeletingCategory ? (
                <p className='small-paragraph mt-2 text-red-500 font-bold'>
                  Atenção: A categoria só será removida se não houver produtos vinculados a ela.
                </p>
              ) : (
                <p className='small-paragraph mt-2 text-gray-400'>
                  Esta ação é irreversível e removerá o arquivo do servidor.
                </p>
              )}
            </div>
          )}
        />
      )}
      {showEmptyConfirm && (
        <SimpleActionPopup
          title="Esvaziar Categoria"
          onClosePopup={() => setShowEmptyConfirm(false)}
          popupLoading={isLoading}
          secondActionButtonText="SIM, APAGAR TUDO"
          secondActionButtonStyle={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}
          onPressSecondActionButton={handleEmptyCategory}
          content={(
            <div className='p-6 text-center'>
              <p className='big-paragraph'>
                Você deseja remover <strong>TODOS</strong> os produtos da categoria <strong>{selectedSubgroup?.title_pt}</strong>?
              </p>
              <p className='small-paragraph mt-4 p-3 bg-orange-50 text-orange-700 rounded-lg border border-orange-200'>
                Esta ação apagará permanentemente todos os itens desta categoria e seus respectivos arquivos no servidor.
              </p>
            </div>
          )}
        />
      )}
      {showBulkPopup && (
        <BulkUploadPopup
          subgroup={selectedSubgroup}
          onClose={() => {
            setShowBulkPopup(false)
            setSelectedSubgroup(null)
          }}
          onSubmit={handleBulkUpload}
          isLoading={isLoading}
          uploadProgress={uploadProgress}
          uploadTotal={uploadTotal}
        />
      )}
      {showImagePreview && (
        <SimpleActionPopup
          title="Visualização do Produto"
          onClosePopup={() => setShowImagePreview(false)}
          showClose={true}
          containerStyle={{ maxWidth: '400px', width: '90vw' }}
          content={(
            <div className='flex justify-center items-center bg-gray-100 rounded-b-xl'>
              <img 
                src={previewImageUrl} 
                className='max-w-full max-h-[60vh] object-contain rounded-lg shadow-lg' 
                alt="Preview grande"
              />
            </div>
          )}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({ token: state.user.token })
export default connect(mapStateToProps)(ColoringManagement)